import styles from './OverlayLoader.module.scss';
import { Loader } from '../Loader';

interface LoaderProps {
  size?: number;
  color?: string;
  text?: string;
}

export const OverlayLoader: React.FC<LoaderProps> = ({ size = 20, color, text }) => {
  return (
    <div className={styles.loader__overlay_container}>
      <Loader
        size={size}
        color={color}
        text={text}
      />
    </div>
  );
};
